const s = {
  name: "CurrencyQatariRiyalV2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26,11h-5v18h2v-8h3c0.1,0,0.2,0,0.3,0l2.6,8H31l-2.8-8.5C29.9,19.7,31,18,31,16C31,13.2,28.8,11,26,11z
			 M26,19h-3v-6h3c1.7,0,3,1.3,3,3C29,17.7,27.7,19,26,19z"/>
		<path class="st0" d="M14,29c-2.8,0-5-2.2-5-5v-8c0-2.8,2.2-5,5-5s5,2.2,5,5v8c0,0.8-0.2,1.5-0.5,2.1l1.5,1.5L18.6,29l-1.3-1.3
			C16.4,28.5,15.3,29,14,29z M17,24.5c0-0.2,0-0.4,0-0.5v-8c0-1.6-1.3-3-3-3s-3,1.3-3,3v8c0,1.7,1.4,3,3,3c0.7,0,1.4-0.3,1.9-0.7
			L13.5,24l1.4-1.4L17,24.5z"/>
		<path class="st0" d="M20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20S9,0,20,0z M2,20c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18
			S29.9,2,20,2C10.1,2,2,10.1,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyQatariRiyalV2
};
